import React, { Component } from 'react';
import {
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';
import Moment from 'moment';
import { Localization } from 'react-widgets'
import momentLocalizer from "react-widgets-moment";
import NetworkEmptyState from '../../commons/networkemptystate';
import Loader from '../../commons/loader';
import { ProgressButton } from '../../commons/ProgressButton';
import Services from './Services';
import NumberFormatter from '../../commons/NumberFormatter';
import RFForm from '../../components/Form/RFForm';
import RFField from '../../components/Form/RFField';
import TimeFormatter from '../../commons/TimeFormatter';
// import SwitchButtonDynamic from '../../../../commons/SwitchButtonDynamic';

Moment.locale('hu');
const localizer = new momentLocalizer(Moment);

// momentLocalizer(Moment);

const CONSTANTS = {
  fizetesiModAzonositok: ['KP', 'UTA', 'PPOS'],
};

/**
 * Osztály partner űrlap létrehozására.
 * @extends Component
 */
class TeremberlesFizetesUrlap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentId: null,
      saveButtonLoading: false,
      modalFizetes: false,
      // MODAL FORM VALUES
      bizonylatszam: '',
      aktivFizetes: 0,
    };
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if ((this.props.modalFizetes !== prevProps.modalFizetes ) && this.props.modalFizetes) {
      if (this.props.hasFizKarbRole)
        this.initTeremberlesFizetes(this.props.id, CONSTANTS.fizetesiModAzonositok);
      else
        this.initTeremberlesFizetesView(this.props.id);
    }
  }

  renderLoader = () => {
    return (
      <div className="showbox">
        <div className="loader">
          <svg className="circular" viewBox="25 25 50 50">
            <circle className="path" cx="50" cy="50" r="20" fill="none" />
          </svg>
        </div>
      </div>
    );
  }

  initTeremberlesFizetes = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initTeremberlesFizetes(id, CONSTANTS.fizetesiModAzonositok, (err, res) => {
      if (!err) {
        let fizModOptions = res[0].fizmod.map(e => <option key={e.variansid ? e.variansid : e.id} value={e.variansid ? e.variansid : e.id}>{e.variansnev ? e.variansnev : e.nev}</option>);

        this.setState({
          formStatus: 'DATA',
          // formType: 'MOD',
          fizModOptions: fizModOptions,
          fizmodValue: res[0].teremberles && res[0].teremberles.fizetesimodid ? res[0].teremberles.fizetesimodid : '',
          bizonylatszamValue: res[0].teremberles && res[0].teremberles.bizonylatszam,
          teremberlesObj: res[0].teremberles
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  initTeremberlesFizetesView = (id) => {
    this.setState({
      formStatus: 'LOAD'
    });
    Services.initTeremberlesFizetesView(id, (err, res) => {
      if (!err) {
        this.setState({
          formStatus: 'DATA',
          // formType: 'MOD',
          teremberlesObj: res[0].teremberles
        });
      } else {
        this.setState({
          formStatus: 'NETW'
        });
      }
    });
  }

  renderFizetesForm = () => {
    return (
      <React.Fragment>
        <div className="col-md-12">
          <h5>{this.state.teremberlesObj && this.state.teremberlesObj.nev}</h5>
          <br />
          <h6>Alapadatok:</h6>
          <b>Helyszín: </b>{this.state.teremberlesObj && this.state.teremberlesObj.helyszin} - {this.state.teremberlesObj && this.state.teremberlesObj.terem}<br />
          <b>Időpont: </b>{TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj && this.state.teremberlesObj.kezdeteidopont)} - {TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj && this.state.teremberlesObj.vegeidopont)}<br />
          <b>Bérleti díj (bruttó): </b>{this.state.teremberlesObj && (this.state.teremberlesObj.dij || 0 === this.state.teremberlesObj.dij) ? (NumberFormatter.addSpacesToString(this.state.teremberlesObj.dij, NumberFormatter.OSSZEG) + (this.state.teremberlesObj.penznem ? ' ' + this.state.teremberlesObj.penznem : '')): '' }<br />
          <br />
          <h6>Bérlő adatok:</h6>
          <b>Név: </b>{this.state.teremberlesObj && this.state.teremberlesObj.partner && this.state.teremberlesObj.partner.nev}<br />
          <b>Partnercsoport: </b>{this.state.teremberlesObj && this.state.teremberlesObj.partner && this.state.teremberlesObj.partner.partnercsoport}<br />
          <b>Email: </b>{this.state.teremberlesObj && this.state.teremberlesObj.partner && this.state.teremberlesObj.partner.email}<br />
          <b>Telefon: </b>{this.state.teremberlesObj && this.state.teremberlesObj.partner && this.state.teremberlesObj.partner.telefon}<br />
          <br />
          <h6>Fizetés adatok:</h6>
          {this.renderFizetesAdatok()}
        </div>
      </React.Fragment>
    );
  }

  // Régi megvalósítás, ahol a fizetett állapotú terembérlésben is lehet módosítani a bizonylatszámot és a fizetési módot - MG
  // renderFizetesAdatok = () => {
  //   if (this.props.hasFizKarbRole) {
  //     if (this.state.teremberlesObj && this.state.teremberlesObj.allapot && 'FIZETETT' === this.state.teremberlesObj.allapot.name) {
  //       return (
  //         <React.Fragment>
  //           <b>Fizetés időpontja: </b>{this.state.teremberlesObj && this.state.teremberlesObj.fizetesidopont && TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.fizetesidopont)}<br />
  //           {this.renderFizetesiMezok()}
  //         </React.Fragment>
  //       );
  //     } else {
  //       return this.renderFizetesiMezok();
  //     }
  //   } else {
  //     return (
  //       <React.Fragment>
  //         {/* <h6>NINCS fizkarb szerepkör</h6>; */}
  //         <b>Fizetés módja: </b>{this.state.teremberlesObj && this.state.teremberlesObj.fizmod}<br />
  //         <b>Fizetés időpontja: </b>{this.state.teremberlesObj && this.state.teremberlesObj.fizetesidopont && TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.fizetesidopont)}<br />
  //         <b>Bizonylatszám: </b>{this.state.teremberlesObj && this.state.teremberlesObj.bizonylatszam}<br />
  //       </React.Fragment>
  //     );
  //   }
  // }

  renderFizetesAdatok = () => {
    if (this.props.hasFizKarbRole && this.state.teremberlesObj && this.state.teremberlesObj.allapot && 'ROGZITETT' === this.state.teremberlesObj.allapot.name) {
      return (
        <React.Fragment>
          <b>Fizetés időpontja: </b>{this.state.teremberlesObj && this.state.teremberlesObj.fizetesidopont && TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.fizetesidopont)}<br />
          {this.renderFizetesiMezok()}
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <b>Fizetés módja: </b>{this.state.teremberlesObj && this.state.teremberlesObj.fizmod}<br />
        <b>Fizetés időpontja: </b>{this.state.teremberlesObj && this.state.teremberlesObj.fizetesidopont && TimeFormatter.formatDateTimeWithoutSeconds(this.state.teremberlesObj.fizetesidopont)}<br />
        <b>Bizonylatszám: </b>{this.state.teremberlesObj && this.state.teremberlesObj.bizonylatszam}<br />
      </React.Fragment>
    );
  }

  renderFizetesiMezok = () => {
    return (
      <React.Fragment>
        <div className="col-md-12">
            <RFField
              label={'Bizonylatszám:'}
              type="text"
              name="bizonylatszamValue"
              id="bizonylatszam"
              value={this.state.bizonylatszamValue}
              onChange={this.handleInputChange}
            />
        </div>
        <div className="col-md-12">
            <RFField
              label={'Fizetés módja:'}
              type="select"
              name="fizmodValue"
              id="fizmod"
              value={this.state.fizmodValue}
              onChange={this.handleInputChange}
              defaultSelect={<option key="fizmod" value="">Válassz fizetési módot!</option>}
              selectOptions={this.state.fizModOptions}
            />
        </div>
        <div className="col-md-12" style={{ textAlign: 'center' }}>
        {/* <SwitchButtonDynamic active={this.state.aktivFizetes} labels={this.state.fizModOptions} widths={[null,null,null]} toggles={[this.toggle(1), this.toggle(2),this.toggle(3)]}/> */}
        {/* <SwitchButtonDynamic active={this.state.aktivFizetes} labels={this.state.fizModOptions} widths={[null,null,null]} toggle={this.toggle}/> */}
        </div>
      </React.Fragment>
    );
  }

  // toggle = (i) => {
  //   // this.setState({ aktivFizetes: i});
  // }

  handleInputChange = (e) => {
    const { target } = e;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    this.setState({
      [name]: value
    });
  }

  submitForm = () => {
    this.setState({
      saveButtonLoading: true
    });

    let submitObj = {};
    submitObj.id = this.props.id;
    if (this.props.hasFizKarbRole) {
      submitObj.bizonylatszam = this.state.bizonylatszamValue;
      submitObj.fizetesimodid = this.state.fizmodValue;
    }

    Services.modifyTeremberlesFizetes(this.props.id, this.state.bizonylatszamValue, this.state.fizmodValue, (err) => {
      if (!err) {
        this.props.globals.addSuccess('Terembérlés sikeresen fizetve!');
        this.setState({
          saveButtonLoading: false
        }, () => {
          this.props.toggleFizetesModal();
          this.props.list();
        });
      } else {
        this.setState({
          saveButtonLoading: false
        });
      }
    });
  }

  render() {
    return (
      <Localization date={localizer}>
        {this.props.hasFizKarbRole ? (
          // <Modal isOpen={this.props.modalFizetes} toggle={this.props.toggleFizetesModal} backdrop="static">
            <RFForm
              onSubmit={this.submitForm}
              modalInsert
              title={'Terembérlés fizetése'}
              tagProps={{ isOpen: this.props.modalFizetes, toggle: this.props.toggleFizetesModal, backdrop: 'static' }}
              footer={
                <React.Fragment>
                   {this.state.teremberlesObj && this.state.teremberlesObj.allapot && 'ROGZITETT' === this.state.teremberlesObj.allapot.name && (
                    <ProgressButton
                      className="btn-cursor-pointer"
                      color="primary"
                      loading={this.state.saveButtonLoading}
                      onClick={this.submitForm}
                    >
                      {'Fizetés'}
                    </ProgressButton>
                  )}
                  <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.props.toggleFizetesModal}>Bezárás</Button>
                </React.Fragment>
              }
            >
              {/* <ModalHeader>Terembérlés fizetése</ModalHeader>
              <ModalBody> */}
                {{
                  LOAD: (<Loader />),
                  NETW: (<NetworkEmptyState
                    hasImage
                    submitClick={() => {this.initTeremberlesFizetes(this.props.id, CONSTANTS.fizetesiModAzonositok)}}
                  />),
                  DATA: (this.renderFizetesForm())
                }[this.state.formStatus]}
              {/* </ModalBody>
              <ModalFooter>
                {this.state.teremberlesObj && this.state.teremberlesObj.allapot && 'ROGZITETT' === this.state.teremberlesObj.allapot.name && (
                    <ProgressButton
                    className="btn-cursor-pointer"
                    color="primary"
                    loading={this.state.saveButtonLoading}
                    >
                      {'Fizetés'}
                    </ProgressButton>
                )}
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.props.toggleFizetesModal}>Bezárás</Button>
              </ModalFooter> */}
            </RFForm>
          /* </Modal> */
          ) : (
            <Modal isOpen={this.props.modalFizetes} toggle={this.props.toggleFizetesModal} backdrop="static">
            <ModalHeader>Terembérlés megtekintése</ModalHeader>
            <ModalBody>
              {{
                LOAD: (<Loader />),
                NETW: (<NetworkEmptyState
                  hasImage
                  submitClick={() => { this.initTeremberlesFizetesView(this.props.id); }}
                />),
                DATA: (this.renderFizetesForm())
              }[this.state.formStatus]}
            </ModalBody>
            <ModalFooter>
                <Button type="button" color="secondary" className="btn-cursor-pointer" onClick={this.props.toggleFizetesModal}>Bezárás</Button>
            </ModalFooter>
        </Modal>
        )}
      </Localization>
    );
  }
}

export default TeremberlesFizetesUrlap
